import { render, staticRenderFns } from "./concise.vue?vue&type=template&id=b91bb3c0&scoped=true"
import script from "./concise.vue?vue&type=script&lang=js"
export * from "./concise.vue?vue&type=script&lang=js"
import style0 from "./concise.vue?vue&type=style&index=0&id=b91bb3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91bb3c0",
  null
  
)

export default component.exports